import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './PersonModal.scss';
import PersonForm from '../../Event/EventPersons/PersonForm/PersonForm';
import { useTranslation } from 'react-i18next';
import PersonEmailVerification from '../../Event/EventPersons/PersonEmailVerification/PersonEmailVerification';

function PersonModal(props) {
    const { eventID, person: personInProps } = props;
    const [person, setPerson] = useState({});
    const [personIsLinked, setPersonIsLinked] = useState(false);
    const [emailVerification, setEmailVerification] = useState(!person.personID);
    const [email, setEmail] = useState('');
    const { t } = useTranslation();
    
    const handleCallback = () => {
        props.callback();
        props.onHide();
    };


    useEffect(() => {
        if (personInProps) {
            setPerson(personInProps);
            setEmailVerification(!personInProps.personID);
        }
    }, [personInProps]);


    return (
        <Modal
            show={props.show}
            onHide={handleCallback}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {person.personID ? t('persons.edit_person') : t('persons.create_person')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {emailVerification ?
                    <PersonEmailVerification
                        email={email}
                        setEmail={setEmail}
                        setPerson={setPerson}
                        setPersonIsLinked={setPersonIsLinked}
                        setEmailVerification={setEmailVerification}
                        eventID={eventID}
                        onClose={handleCallback}
                    />
                :
                    <PersonForm
                        person={{
                            ...person,
                            emails: person.emails || [{ email }]
                        }}
                        personIsLinked={personIsLinked}
                        callback={handleCallback}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="default" onClick={handleCallback}>
                    {t('general.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PersonModal;